<template>
  <v-container fill-height class="ma-0 pa-0 align-center justify-center" style="width: 100%">
    <div class="box-container ma-0 pa-0" style="width: 100%; max-width: 600px">
      <!-- <div class="row-header ma-0 pa-0" v-if="!isOnMobile">
        <v-row justify="center" align="center" class="pa-2">
          <v-divider></v-divider>
          <span class="subtitle-1 mx-4">Движения по сметката на потребителя</span>
          <v-divider></v-divider>
        </v-row>
      </div> -->
      <v-row v-if="!loaded" align="center" justify="center" class="row-header ma-0 pa-0 mt-6">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
        <v-alert justify="center" align="center" :class="loaded ? '' : 'subtitle-2'" :value="true" color="default" :icon="loaded ? 'mdi-emoticon-sad' : ' '">{{ loaded ? (error_message == null ? TR.NoDataForShowing : error_message) : TR.DataProcessingPleaseWait }}</v-alert>
      </v-row>
      <div class="row-content ma-0 pa-0" justify="center" align="center" ref="refGridContainer">
        <v-data-table
          v-if="loaded"
          ref="refGrid"
          class="ma-0 pa-0 elevation-0"
          @click:row="expanded.push($event)"
          :mobile-breakpoint="0"
          :dense="isOnMobile ? true : userSettings.denseGrid"
          item-key="my_custom_id"
          hide-default-footer
          :height="gridHeight"
          :items="getBalanceActions()"
          :headers="dataheaders"
          :show-expand="true"
          :expanded.sync="expanded"
          fluid
          fixed-header
          disable-pagination
          style="width: 100%; max-width: 600px"
        >
          <template v-slot:no-data>
            <v-row align="center" justify="center" class="ma-0 pa-0">
              <v-alert :value="true" color="default" icon="mdi-emoticon-sad">{{ error_message != null ? error_message : TR.NoDataForShowing }}</v-alert>
            </v-row>
          </template>
          <template v-slot:[`header.action`]>
            <th>
              <v-select class="myselect ma-0 pa-0 caption" style="min-height: 100%; min-width: 100%" v-model="currentAction" :items="getDistinctActions()" label="Действие" :item-color="isInDarkMode ? '#FFFFFF' : ''" clearable hide-details single-line outlined> </v-select>
            </th>
          </template>
          <template v-for="(h, index) in dataheaders" v-slot:[`item.${h.value}`]="{ item }">
            <span :key="index" class="data-grid-cell" :class="(h.proptype == DataPropType.Money4digits && Object.byString(item, h.value)) > 0 ? 'success--text' : ''" style="cursor: pointer" :style="h.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + h.cell_align + ';'">
              {{ formatCell(h.proptype, Object.byString(item, h.value)) }}
              <v-icon v-if="h.value == 'action' && item.amount > 0 && item.details[0].text.startsWith('Invoice')" class="pl-2">mdi-file-pdf</v-icon>
            </span>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td class="ma-0 pa-0"></td>
            <td :colspan="headers.length - 1" class="ma-0 pa-0">
              <v-data-table :dense="isOnMobile ? true : userSettings.denseGrid" class="ma-0 pa-0 elevation-0" disable-pagination :headers="dataheadersexpanded" :items="item.details" item-key="my_custom_id" hide-default-footer hide-default-header>
                <template v-for="(hh, indexx) in dataheadersexpanded" v-slot:[`item.${hh.value}`]="{ item }">
                  <template v-if="hh.value == 'text' && item[hh.value] && item[hh.value].startsWith('Invoice')">
                    <div :key="indexx" class="data-grid-cell" style="cursor: pointer" :style="hh.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + hh.cell_align + ';'" @click="openInvoice(Object.byString(item, hh.value))">
                      <v-icon class="pr-2" small>mdi-magnify</v-icon>
                      <span style="text-decoration: underline">
                        {{ TR.Invoice + " " + formatCell(hh.proptype, Object.byString(item, hh.value)).replace("Invoice_", "").replace(".pdf", "") }}
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <span :key="indexx" class="data-grid-cell" :style="hh.cell_align == 'center' ? 'justify-content: center;' : 'justify-content: flex-' + hh.cell_align + ';'">
                      {{ formatCell(hh.proptype, Object.byString(item, hh.value)) }}
                    </span>
                  </template>
                </template>
              </v-data-table>
            </td>
          </template>
          <template v-slot:[`header.amount`]="{ header }">
            <div>
              <span style="white-space: pre-wrap">
                {{ header.text + "\n" }}
                <span :class="userBalance < 0 ? 'error--text' : 'success--text'">{{ formatCell(DataPropType.Money, userBalance) }}</span>
              </span>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
  </v-container>
</template>

<script>
import DataManager, { DataHeader, DataPropType, ErrorMessage } from "../../js/DataManager";
import { TR } from "../../main";

export default {
  data() {
    return {
      virtualScrollerOffset: 0,
      loaded: false,
      dialogInvoice: false,
      invoiceData: null,
      gridHeight: "100%",
      DataPropType: DataPropType,
      currentAction: null,
      actions: [this.isOnMobile ? TR.Charging : TR.ChargingDaily, this.isOnMobile ? TR.BalancePay : TR.BalancePayment, this.isOnMobile ? TR.Bonus : TR.BonusPayment],
      balanceActions: [],
      expanded: [],
      plans: [],
      error_message: null,
      userBalance: 0,
      dataheaders: [],
      dataheadersexpanded: [new DataHeader("", "text", DataPropType.String, "left", false, false, true), new DataHeader("", "description", DataPropType.String, "center", false, false, true), new DataHeader("", "amount", DataPropType.Money4digits, "end", false, false, true)],
      datatype: null,
      TR: TR,
    };
  },
  computed: {},
  methods: {
    setTitleAndData(meta, error) {
      this.datatype = meta.datatype;
      // DataManager.loadData(
      //   DataManager.DataType.user,
      //   (eu) => {
      //     if (eu.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
      //       this.userBalance = DataManager.getData(DataManager.DataType.user).balance;
      //     }
      //   },
      //   true
      // );
      this.balanceActions = [];
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        DataManager.loadData(
          DataManager.DataType.user,
          () => {
            var balance = DataManager.getData(DataManager.DataType.user).balance;
            if (balance == this.balance) {
              this.loadData();
            } else {
              DataManager.loadData(
                DataManager.DataType.balance_charges,
                () => {
                  this.loadData();
                },
                true,
              );
            }
            this.userBalance = balance;
          },
          true,
        );
      } else {
        this.loaded = true;
        this.error_message = error.Message;
        this.dialogLoader.showError(error.Message, { location: "center" });
      }
    },
    getDistinctActions() {
      return this.balanceActions.map((a) => a.action).unique();
    },
    getBalanceActions() {
      if (!this.currentAction) return this.balanceActions;
      else return this.balanceActions.filter((f) => f.action == this.currentAction);
    },
    loadData() {
      this.plans = DataManager.getData(DataManager.DataType.subscription_plans);
      const balanceActz = DataManager.getData(this.datatype, true);
      //console.log(JSON.stringify(balanceActz));
      this.balanceActions = balanceActz.map((b) => ({
        action: this.actions[0],
        date: b.date,
        amount: -b.amountCharged,
        details: b.devDayChargeEntries.map((item, idx) => ({
          text: idx + 1 + ".  " + item.devSN,
          description: this.plans.find((p) => item.planIdTemp == p.id).name,
          incoming: false,
          amount: -item.amountCharged,
        })),
      }));
      DataManager.loadData(
        DataManager.DataType.balance_payments,
        (error2) => {
          if (error2.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            const paymentz = DataManager.getData(DataManager.DataType.balance_payments, true);
            //console.log(JSON.stringify(paymentz));
            const paymentzMap = paymentz.map((p) => ({
              action: p.externalBalanceBonus ? this.actions[2] : this.actions[1],
              date: p.dateRequested,
              amount: p.amount,
              details: [
                {
                  text: p.byDistrib && p.byDistrib.eik != "104593442" ? TR.From + ": " + p.byDistrib.distrName : p.invFileName ? p.invFileName : TR.NoInvoice,
                  amount: p.amount,
                  incoming: true,
                },
              ],
            }));
            if (paymentzMap.length > 0) {
              this.balanceActions.push(...paymentzMap);
            }
            this.balanceActions.sortByDesc("date");
            this.balanceActions = this.balanceActions.map((item, index) => ({
              my_custom_id: index,
              ...item,
            }));
            this.recalcGridHeight();
          } else {
            this.error_message = error2.Message;
            this.dialogLoader.showError(error2.Message, { location: "center" });
          }
          this.$nextTick(() => {
            this.loaded = true;
          });
        },
        true,
      );
    },
    formatCell(proptype, value) {
      return DataManager.formatGridData(proptype, value);
    },
    recalcGridHeight() {
      setTimeout(() => {
        if (this.$refs.refGridContainer && this.$refs.refGridContainer.clientHeight > 0) {
          this.gridHeight = this.$refs.refGridContainer.clientHeight;

          //this.gridHeight = this.headersHeight + this.visibleRows * this.rowHeight + "px";

          // if (this.hasFooter) {
          //   this.visibleRows--; //footer
          // }
        }
      }, 1000);
    },
    setFocus(on) {
      if (this.$refs.refGrid) {
        if (on) {
          this.$refs.refGrid.$el.querySelector(".v-data-table__wrapper").scrollTop = this.virtualScrollerOffset; //ако си цъкнал друг таб и се върнеш
        } else {
          this.virtualScrollerOffset = this.$refs.refGrid.$el.querySelector(".v-data-table__wrapper").scrollTop;
        }
      }
    },
  },
  watch: {},
  mounted() {
    this.dataheaders = [{ sortable: false, ...new DataHeader(TR.Action, "action", DataPropType.String, "left") }, new DataHeader(TR.Date, "date", this.isOnMobile ? DataPropType.DateShort : DataPropType.Date, "center"), { sortable: false, ...new DataHeader(TR.Balance, "amount", DataPropType.Money4digits, "end") }];
    this.dataheaders[0].width = "40%";
    this.dataheaders[1].width = "35%";
    this.dataheaders[2].width = "25%";

    this.dataheadersexpanded[0].width = "75%";
    this.dataheadersexpanded[1].width = "25%";
  },
  created() {
    window.addEventListener("resize", this.recalcGridHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcGridHeight);
  },
};
</script>
<style scoped>
.centered-input >>> * .v-input__slot:before,
.centered-input >>> * .v-input__slot:after {
  border-style: none;
}

.centered-input /deep/ input {
  padding: 0;
  margin: 0;
}

* >>> .v-slider--horizontal {
  min-height: 15px;
}
</style>